import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BrandService {
  private _logoUrls = signal<{ light: string; dark: string }>({
    light: null,
    dark: null,
  });

  readonly logoUrls = this._logoUrls.asReadonly();

  setLogo(input: string | { light?: string; dark?: string }) {
    if (typeof input === 'string') {
      this._logoUrls.set({ light: input, dark: input });
    } else {
      this._logoUrls.update((prev) => ({ ...prev, ...input }));
    }
  }

  setLogoLight(url: string) {
    this._logoUrls.update((prev) => ({ ...prev, light: url }));
  }

  setLogoDark(url: string) {
    this._logoUrls.update((prev) => ({ ...prev, dark: url }));
  }
}
